import { Injectable, inject } from '@angular/core';

import { FsCookie } from '@firestitch/cookie';
import { parse } from '@firestitch/date';

import { isAfter } from 'date-fns';


@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private _cookieService = inject(FsCookie);


  public getExpiry(): Date {
    const expiry = this._cookieService.get('Token-Expiry');

    return expiry ? parse(expiry) : null;
  }

  public getXsrf(): string {
    return this._cookieService.get('Token-XSRF');
  }

  public isExpired(): boolean {
    const expiry = this.getExpiry();

    return !expiry || isAfter(new Date(), expiry);
  }

  public destroy(): void {
    this._cookieService.delete('Token-Expiry');
    this._cookieService.delete('Token-XSRF');
  }
}
